import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Assuming you have this function for logging

// Assuming ChampStruct has a method to convert to JSON
class ChampStruct {
  constructor(type, content, bb, pp, ww, hh, label, page) {
    this.type = type;
    this.content = content;
    this.bb = bb;
    this.pp = pp;
    this.ww = ww;
    this.hh = hh;
    this.label = label;
    this.page = page;
  }

  toJson() {
    return {
      type: this.type,
      content: this.content,
      bb: this.bb,
      pp: this.pp,
      ww: this.ww,
      hh: this.hh,
      label: this.label,
      page: this.page,
    };
  }
}

const sendHS1 = async (
  champs,
  urlpdf,
  token,
  folderid,
  docid,
  prefix,
  height,
  width,
  fileName = null,
  forDPE = false
) => {
  const url =
    prefix + `hexasign/folders/${folderid}/documents/${docid}/prepare`;

  // Modify Champs types and content as per the original logic
  champs.forEach((champ) => {
    if (champ.type === "Initiales") {
      champ.type = "Signature";
    } else if (champ.type === "Coche") {
      champ.type = "Tampon";
      champ.ww = 20;
      champ.hh = 20;
      champ.content =
        champ.content === "true"
          ? "https://firebasestorage.googleapis.com/v0/b/foundry-2dlu01.appspot.com/o/persistent%2Fcochetrue.png?alt=media&token=54b36cc7-13e9-4a07-8edb-dd87705ca982"
          : "https://firebasestorage.googleapis.com/v0/b/foundry-2dlu01.appspot.com/o/persistent%2Fcochefalse.png?alt=media&token=74043f9c-b3fe-450f-b813-8c5e48a70af2";
    }
  });

  champs = champs.map((champ) =>
    champ instanceof ChampStruct
      ? champ
      : new ChampStruct(
          champ.type,
          champ.content,
          champ.bb,
          champ.pp,
          champ.ww,
          champ.hh,
          champ.label,
          champ.page
        )
  );

  const fields = champs.map((champ) => champ.toJson());

  // Request body
  const body = {
    pdf: urlpdf,
    fields: fields,
    target_height: height,
    target_width: width,
    filename: fileName,
    forDPE: forDPE,
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    let start = new Date();
    // Send POST request using fetch
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.error("User not logged in");
      return "";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));
    const org_id = userSnapshot.get("org_id");

    const responseText = await response.text();
    let end = new Date();
    let elapsed = end - start;
    // Log the request and response
    await addLogDocument(
      url,
      prefix,
      userRef, // Log userRef ID
      org_id,
      response.status.toString(),
      "", // folderid
      "", // docid
      JSON.stringify(body), // request body as string
      responseText,
      "POST",
      elapsed
    );

    // Check response
    if (response.ok) {
    } else {
      console.error(`Failed to send request: ${response.status}`);
      return "";
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    throw new Error("Request failed");
  }
};

export default sendHS1;
